export const ALLOWED_ROLES = ["Behavioral Specialist", "Prescriber", "Case Manager", "Peer"];

export const MODAL_MODES = {
  ADD_GOAL: "addGoal",
  ADD_OBJECTIVE: "addObjective",
  CLOSE_AND_ADD_OBJECTIVE: "closeAndAddObjective",
  COMPLETE_OBJECTIVE: "completeObjective",
  EDIT_OBJECTIVE: "editObjective",
  EMPTY: "empty",
  REMOVE_OBJECTIVE: "removeObjective",
};

export const PROVIDER_TYPE_TO_LABEL = {
  BEHAVIORAL: "Behavioral Specialist",
  CASE_MANAGER: "Case Manager",
  PEER: "Peer",
  PRESCRIBE: "Prescriber",
};
